import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArtiComponent } from './arti.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from '../accordion/accordion.module';



@NgModule({
  declarations: [
    ArtiComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AccordionModule
  ]
})
export class ArtiModule { }
